module.exports = __webpack_public_path__ + "506b35ed8ece0d06c71653a77715524d.ogg";